import Navbar from "../components/Navbar";

const G = "#FFB800";
const G2 = "#FFD700";

export default function Terms() {
  return (
    <div style={s.page}>
      <Navbar />
      <div style={s.container} className="page-container">
        <div style={s.header}>
          <h1 style={s.title}>Terms & Conditions</h1>
          <p style={s.sub}>Last updated: June 2025</p>
        </div>

        <div style={s.card}>
          <div style={s.cardTopLine} />
          <Section title="1. Acceptance of Terms">
            By accessing or using Earnix Global ("Platform"), you agree to be bound by these Terms and Conditions. If you do not agree, please do not use the Platform. These terms apply to all users, including visitors, registered members, and investors.
          </Section>

          <Section title="2. Eligibility">
            You must be at least 18 years of age to use this Platform. By registering, you confirm that you are legally eligible to participate in cryptocurrency investment activities in your jurisdiction. It is your responsibility to ensure that your participation complies with local laws.
          </Section>

          <Section title="3. Investment Plans & Returns">
            Earnix Global offers USDT-based investment plans with daily returns powered by AI-driven trading algorithms. All returns are estimates based on historical performance. Past performance does not guarantee future results. Cryptocurrency investments carry inherent risks, including loss of principal.
          </Section>

          <Section title="4. Deposits & Withdrawals">
            All deposits are made in USDT (Tether). Minimum deposit amount is $5 USDT. Withdrawals are processed within 24 hours subject to admin approval. A processing fee of 5% applies to all withdrawals. Earnix Global reserves the right to hold withdrawals pending verification.
          </Section>

          <Section title="5. Referral Program">
            Earnix Global operates a multi-level referral program. Referral commissions are credited automatically upon successful deposits by referred members. Commission rates are subject to change. Fraudulent referral activities will result in immediate account termination and forfeiture of funds.
          </Section>

          <Section title="6. Prohibited Activities">
            Users are strictly prohibited from:
            {"\n"}• Creating multiple accounts
            {"\n"}• Using bots or automated tools
            {"\n"}• Providing false registration information
            {"\n"}• Engaging in money laundering or illegal activities
            {"\n"}• Attempting to hack, disrupt, or abuse the Platform
          </Section>

          <Section title="7. Account Security">
            You are responsible for maintaining the confidentiality of your login credentials. Earnix Global will never ask for your password or OTP. Report any unauthorized access to support@earnixglobal.com immediately.
          </Section>

          <Section title="8. Risk Disclaimer">
            Cryptocurrency markets are highly volatile. Earnix Global does not guarantee profits. All investments are made at the user's own risk. The platform is not responsible for losses due to market fluctuations, network issues, or user error.
          </Section>

          <Section title="9. Termination">
            Earnix Global reserves the right to suspend or terminate any account without prior notice if a user is found violating these terms, engaging in fraudulent activity, or attempting to manipulate the platform.
          </Section>

          <Section title="10. Changes to Terms">
            These Terms may be updated at any time. Continued use of the Platform after changes constitutes acceptance of the new terms. Users will be notified of significant changes via email.
          </Section>

          <Section title="11. Contact">
            For any questions regarding these Terms, contact us at support@earnixglobal.com or on Telegram <a href="https://t.me/earnix_global" target="_blank" rel="noreferrer" style={{color:"#FFD700", textDecoration:"none"}}>@earnix_global</a>.
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={ss.section}>
      <h3 style={ss.sectionTitle}>{title}</h3>
      <p style={ss.sectionBody}>{children}</p>
    </div>
  );
}

const s = {
  page: { minHeight: "100vh", background: "#03050a", color: "#e0e8ff" },
  container: { maxWidth: 800, margin: "0 auto", padding: "32px 24px" },
  header: { marginBottom: 32 },
  title: {
    fontFamily: "'Figtree', sans-serif",
    fontWeight: 900, fontSize: 32,
    background: `linear-gradient(135deg, ${G2}, ${G})`,
    WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
    margin: 0, marginBottom: 8,
  },
  sub: { color: "rgba(160,180,220,0.5)", fontSize: 13, margin: 0 },
  card: {
    background: "rgba(255,255,255,0.02)",
    border: "1px solid rgba(255,184,0,0.12)",
    borderRadius: 16, padding: "32px",
    position: "relative", overflow: "hidden",
  },
  cardTopLine: {
    position: "absolute", top: 0, left: 0, right: 0, height: 2,
    background: `linear-gradient(90deg, transparent, ${G2}, ${G}, transparent)`,
  },
};

const ss = {
  section: { marginBottom: 28, paddingBottom: 28, borderBottom: "1px solid rgba(255,184,0,0.07)" },
  sectionTitle: {
    fontFamily: "'Figtree', sans-serif",
    fontWeight: 700, fontSize: 16, color: G2, marginBottom: 10, marginTop: 0,
  },
  sectionBody: {
    fontFamily: "'-apple-system','BlinkMacSystemFont','Figtree', sans-serif",
    fontSize: 14, color: "rgba(200,220,255,0.65)",
    lineHeight: 1.8, margin: 0, whiteSpace: "pre-line",
  },
};
